module.exports = __webpack_public_path__ + "img/31.36863d9e.jpg";